import ReactECharts from "echarts-for-react";
import PropTypes from "prop-types";

export default function ChartPie({ theme = "light", data = {} }) {
  const option = {
    tooltip: {
      trigger: 'item'
    },
    legend: {
      top: '5%',
      left: 'center'
    },
    series: [
      {
        name: 'Transacciones',
        type: 'pie',
        radius: ['40%', '70%'],
        avoidLabelOverlap: false,
        itemStyle: {
          borderRadius: 10,
          borderColor: '#fff',
          borderWidth: 2
        },
        label: {
          show: false,
          position: 'center'
        },
        emphasis: {
          label: {
            show: true,
            fontSize: 40,
            fontWeight: 'bold'
          }
        },
        labelLine: {
          show: false
        },
        data: [
          { value: data?.factura01 ?? 0, name: "Factura" },
          { value: data?.boleta03 ?? 0, name: "Boleta" },
          { value: data?.cotizacionesCO ?? 0, name: "Cotización" },
          { value: data?.comprasOC ?? 0, name: "Compra" },
          { value: data?.guiaremision09 ?? 0, name: "Guía de remisión" },
          { value: data?.notacredito07 ?? 0, name: "Nota de crédito" },
          { value: data?.notadebito08 ?? 0, name: "Nota de débito" },
        ]
      }
    ]
  };

  return (
    <ReactECharts
      option={option}
      theme={theme}
      style={{ height: 400, width: "100%" }}
    />
  );
}

ChartPie.propTypes = {
  theme: PropTypes.string,
  data: PropTypes.object,
};